/* global axios */
import ApiClient from './ApiClient';

class TelephonyAPI extends ApiClient {
  constructor() {
    super('telephony', { accountScoped: true });
  }

  // Banner: is telephony active for this agent + is their IP Russian.
  networkCheck() {
    return axios.get(`${this.url}/network_check`);
  }

  // На каких телефонных инбоксах у этого оператора есть своя линия в АТС.
  myLines() {
    return axios.get(`${this.url}/my_lines`);
  }
}

export default new TelephonyAPI();
